import React from 'react';
import { Redirect } from 'react-router-dom';

function SalesTeamRedirect() {
  return <Redirect to="/sales-task-list?tab=sales_users" />;
}

export default SalesTeamRedirect;
